import request from '@/utils/request'


// 查询使用记录列表
export function listHistory(query) {
  return request({
    url: '/cio/cio-history/list',
    method: 'get',
    params: query
  })
}

// 查询使用记录分页
export function pageHistory(query) {
  return request({
    url: '/cio/cio-history/page',
    method: 'get',
    params: query
  })
}

// 查询使用记录详细
export function getHistory(data) {
  return request({
    url: '/cio/cio-history/detail',
    method: 'get',
    params: data
  })
}

// 新增使用记录
export function addHistory(data) {
  return request({
    url: '/cio/cio-history/add',
    method: 'post',
    data: data
  })
}

// 修改使用记录
export function updateHistory(data) {
  return request({
    url: '/cio/cio-history/edit',
    method: 'post',
    data: data
  })
}

// 删除使用记录
export function delHistory(data) {
  return request({
    url: '/cio/cio-history/delete',
    method: 'post',
    data: data
  })
}
